// extracted by mini-css-extract-plugin
module.exports = {"Videos":"Videos_Videos__3XHFV"};